// ChartDataLoading.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import styles from '../../../../css/charts.module.css'

function ChartDataLoading () {
  return (
    <div className={styles.noChartData}>
      <FormattedMessage
        id='chart.loading'
        defaultMessage='Data for chart loading'
        description='Data for chart loading'
        tagName='h3'
      />
    </div>
  )
}

export default ChartDataLoading
